// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomerTypeBar/customertypebar.css
// module id = 1707
// module chunks = 0